export default __webpack_public_path__ + "static/media/tick.8572b78c.png";